import {
  makeStyles,
  SelectTabEventHandler,
  Tab,
  TabList,
  tokens,
} from '@fluentui/react-components';
import { useUser } from '@auth/AuthContext';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

export default function TabView() {
  const { groovUser, hasAccess } = useUser();
  const { pathname } = useLocation();
  const navigation = useNavigate();

  const handleTabSelect: SelectTabEventHandler = (_, data) => {
    if (typeof data.value === 'string') {
      navigation(data.value);
    }
  };

  const currentTab = pathname.split('/').filter(Boolean).pop();

  const styles = useStyles();

  // Should never be the case as this is handled in the router
  if (!groovUser) return null;

  return (
    <div>
      <TabList selectedValue={currentTab} onTabSelect={handleTabSelect}>
        {hasAccess(['Leader', 'Manager']) && <Tab value="insights">Insights</Tab>}
        {/* <Tab value="settings">Settings</Tab> */}
      </TabList>
      <div className={styles.tabContent}>
        <Outlet />
      </div>
    </div>
  );
}

const useStyles = makeStyles({
  tabContent: {
    paddingLeft: '12px',
  },
  customerError: {
    borderRadius: tokens.borderRadiusXLarge,
  },
  title: {
    marginBottom: tokens.spacingVerticalS,
  },
  description: {
    maxWidth: '80%',
    marginBottom: tokens.spacingVerticalXXXL,
    '@media screen and (min-width: 768px)': { maxWidth: '66%' },
  },
});
